module.exports = __webpack_public_path__ + "img/beer_id-99.8e402f12.png";